import { List, Datagrid, TextField, ReferenceField } from "react-admin";

import LayoutContainer from "../components/LayoutContainer";
import PhoneField from "../components/PhoneField";
import useDataGridStyles from "../components/DataGridStyle";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import exporter from "../../../utils/exporter";
import PermissionChecker from "../../../components/PermissionChecker";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";
// const useStyles = makeStyles((theme) => ({
//   container: {
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     overflow: "auto",
//   },
// }));

const UserList = (props) => {
  const title = "Users";
  const headers = [
    { label: "Username", source: "username" },
    { label: "Firstname", source: "firstname" },
    { label: "Lastname", source: "lastname" },
    { label: "Role", source: "job_title" },
    { label: "Phone", source: "phone" },
    { label: "Status", source: "status" },
    { label: "Last Access", source: "last_access_time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Users" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        exporter={(data) => exporter(data, headers, title)}
        bulkActionButtons={false}
        classes={{ content: classes.content }}
        actions={<CustomAction labelCreate="Add User" />}
      >
        <Datagrid
          classes={{ headerCell: classes.header, rowCell: classes.row }}
          rowClick="edit"
        >
          <TextField source="username" />
          <TextField source="firstname" />
          <TextField source="lastname" />
          <ReferenceField
            label="Role"
            source="role_id"
            reference="merchant-roles"
          >
            <TextField source="name" />
          </ReferenceField>

          <PhoneField label="Phone" source="phone" />
          <TextField label="Status" source="status" />

          <CustomDateField label="Last Access" source="last_access_time" />
        </Datagrid>
      </List>
      <PermissionChecker code="Page.Merchant.Management.User" />
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default UserList;
